export const STATUS_UPDATE_ERROR_TITLE = "Failed to update task status";
export const TASK_CREATION_ERROR_TITLE = "Failed to create task ";
export const TASK_DUPLICATION_ERROR_TITLE = "Failed to duplicate task ";
export const TASK_REORDER_ERROR_TITLE = "Failed to reorder task";
export const TITLE_UPDATE_ERROR_TITLE = "Failed to update task title";
export const TASK_TAG_UPDATE_ERROR_TITLE = "Failed to update the tag for this task";
export const TASK_PROJECT_UPDATE_ERROR_TITLE = "Failed to update the project for this task";
export const DESCRIPTION_UPDATE_ERROR_TITLE = "Failed to update task description";
export const DELETE_TASK_ERROR_TITLE = "Failed to delete task ";
export const TASK_DURATION_UPDATE_ERROR_TITLE = "Failed to update task duration";
export const TASK_TIME_SPENT_UPDATE_ERROR_TITLE = "Failed to update task time spent";
export const TASK_DATE_UPDATE_ERROR_TITLE = "Failed to update task date";
export const TASK_TIME_UPDATE_ERROR_TITLE = "Failed to update task time";
export const TASK_DUE_DATE_UPDATE_ERROR_TITLE = "Failed to update task due date";
export const TASK_DND_UPDATE_ERROR_TITLE = "Failed to update task order and date";

export const TAG_CREATION_ERROR_TITLE = "Failed to create tag";
export const TAG_UPDATE_ERROR_TITLE = "Failed to update tag";
export const TAG_DELETE_ERROR_TITLE = "Failed to delete tag";

export const ERROR_TRY_AGAIN_MESSAGE = "Please refresh and try again";

// Error to show when user attempts to select more than 10 tags for filtering.
// Displayed when they attempt to select an 11th tag.
export const TAG_FILTER_LIMIT_REACHED_ERROR = {
    title: "Filter limit reached",
    description: "You can only filter on 10 tags at a time. Please unselect a tag filter to add another.",
    duration: 5000,
};

// Error for if the user has >10 tags selected in the database. We want to alert
// them that the list may not show all the tasks they expect.
export const TAG_FILTER_LIMIT_REACHED_BAD_DB_STATE_ERROR = {
    title: "Error: Too many tags selected",
    description: "You have filtered on too many tags. Only tasks from the first 10 selected tags will be shown.",
    duration: 60000,
};
